import './LaunchScreen.scss';

import React from 'react';

import LogoSpinner from 'src/component/UI/LogoSpinner';
import { LanguageProvider } from 'src/i18n/LanguageContext';
import { useTranslation } from 'src/i18n';

function LaunchContent () {
  const { t } = useTranslation();
  return (
    <div id='launch-screen' style={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
      <LogoSpinner size={180} />
      <p>{t('common.loading')}</p>
    </div>
  );
}

export default function LaunchScreen () {
  return (
    <LanguageProvider>
      <LaunchContent />
    </LanguageProvider>
  );
}
